import { graphql } from "../../generated";

export const REQUEST_PASSWORD_RESET = graphql(`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`);
